var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightarrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 22,
    viewBox: "0 0 13 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.433159 21.6789C0.911796 22.1079 1.68589 22.1079 2.16334 21.6789L12.2833 12.5885C12.5098 12.3881 12.6902 12.1469 12.8134 11.8796C12.9367 11.6123 13.0002 11.3245 13.0002 11.0336C13.0002 10.7427 12.9367 10.4549 12.8134 10.1876C12.6902 9.92032 12.5098 9.67915 12.2833 9.47877L2.09007 0.321271C1.85873 0.116614 1.55238 0.00158245 1.23322 -0.000460595C0.914069 -0.00250364 0.606044 0.108595 0.371705 0.310271C0.255617 0.409866 0.162731 0.530581 0.0988001 0.664943C0.0348689 0.799305 0.00125305 0.944453 3.43676e-05 1.0914C-0.00118431 1.23834 0.0300201 1.38396 0.0917152 1.51922C0.15341 1.65448 0.244283 1.77652 0.358705 1.87777L9.68798 10.2565C9.80134 10.3567 9.8916 10.4773 9.95329 10.611C10.015 10.7447 10.0468 10.8887 10.0468 11.0342C10.0468 11.1797 10.015 11.3237 9.95329 11.4574C9.8916 11.5911 9.80134 11.7117 9.68798 11.8119L0.433159 20.1246C0.319835 20.2247 0.229589 20.3452 0.167919 20.4788C0.106249 20.6124 0.0744454 20.7563 0.0744454 20.9017C0.0744454 21.0471 0.106249 21.191 0.167919 21.3246C0.229589 21.4582 0.319835 21.5788 0.433159 21.6789Z",
    fill: "#FFCA2B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrow);
export default __webpack_public_path__ + "static/media/rightarrow.5ae147c13bf3ba3b20e7b9547c784460.svg";
export { ForwardRef as ReactComponent };